import { NgModule } from '@angular/core';
/** @TODO 考虑把这两个组件移动到router文件夹下 */
import { CouponListComponent } from '@root/component/coupon-list/coupon-list.component';
import { SystemNotificationComponent } from '@root/component/system-notification/system-notification.component';

import { SharedModule } from "@root/shared/shared.module";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { MessageContainerComponent } from "@root/router/component/message/message-container/message-container.component";
import { MessageComponent } from "@root/router/component/message/message/message.component";
import { ClientComponent } from "./customer-service/client/client.component";
import { MessageItemComponent } from "./customer-service/message-item/message-item.component";
import { MESSAGE_DEFAULT_CONFIG_PROVIDER } from "@root/router/component/message/message.config";
import { TodayOrTomorrowOrderListComponent } from "./today-or-tomorrow-order-list/today-or-tomorrow-order-list.component";
import { NoteV2Component } from "./note-v2/note-v2.component";
import { ComponentModule } from "@root/component/component.module";
import { SynTaskListComponent } from "./syn-task-list/syn-task-list.component";
import { DuplicateGuestComponent } from "./guest/duplicate-guest/duplicate-guest.component";
import { EditGuestComponent } from "./guest/edit-guest/edit-guest.component";
import { GuestTagComponent } from "./guest/guest-tag/guest-tag.component";
import { HourRoomCalendarComponent } from "./hour-room-calendar/hour-room-calendar.component";
import { VerticalTaskCalendarComponent } from './vertical-task-calendar/task-calendar.component';
import { HouseOrderDetailComponent } from './house-order-detail/house-order-detail.component';
import { HouseOrderBasicComponent } from './house-order-detail/house-order-basic/house-order-basic.component';
import { HouseOrderFinanceComponent } from './house-order-detail/house-order-finance/house-order-finance.component';
import { ContinueStayComponent } from './house-order-detail/house-order-basic/continue-stay/continue-stay.component';
import { FinanceCompleteTableComponent } from './house-order-detail/house-order-finance/finance-complete-table/finance-complete-table.component';
import { HouseOrderGuestComponent } from './house-order-detail/house-order-guest/house-order-guest.component';
import { OrderGuestDetailComponent } from './house-order-detail/house-order-guest/order-guest-detail/order-guest-detail.component';
import { OrderGuestSimilarComponent } from './house-order-detail/house-order-guest/order-guest-similar/order-guest-similar.component';
import { AuditDetailsComponent } from '@root/router/properties/audit-details/audit-details.component';
import { FailHousesComponent } from '@root/router/properties/fail-houses/fail-houses.component';
import { AirbnbAuthRequirementComponent } from './airbnb-auth-requirement/airbnb-auth-requirement.component';
import { EditTemplateComponent } from './template/edit-template/edit-template.component';
import { OrderDetailSidebarComponent } from './order-detail-sidebar/order-detail-sidebar.component';
import { RateDetailComponent } from './house-order-detail/rate-detail/rate-detail.component';

import { EditRateComponent } from './rate/edit-rate/edit-rate.component';
import { RateTplPickerComponent } from './rate/rate-tpl-picker/rate-tpl-picker.component';
import { CreateTaskComponent } from './task/create-task/create-task.component';
import { TaskDetailSidebarComponent } from './task/task-detail-sidebar/task-detail-sidebar.component';
import { DepositComponent } from './deposit/deposit.component';
import {HouseSelectComponent} from "@root/router/component/house-select/house-select.component";
import {CleanerAssignPickerComponent} from "@root/router/component/cleaner-assign-picker/cleaner-assign-picker.component";
import {BaseCalendarComponent} from "@root/router/component/calendar-picker/base-calendar/base-calendar.component";
import {OversaleCalendarComponent} from "@root/router/component/calendar-picker/oversale-calendar/oversale-calendar.component";
import { StopHouseCalendarComponent } from './calendar-picker/stop-house-calendar/stop-house-calendar.component';
import {WidgetCheckGuideMenuComponent} from "@root/router/component/house-order-detail/widgets/check-guide-menu/check-guide-menu.component";
import {WidgetDepositComponent} from "@root/router/component/house-order-detail/widgets/deposit/deposit.component";
import {WidgetRemarkComponent} from "@root/router/component/house-order-detail/widgets/remark/remark.component";
import { ConditionSwitchPickerComponent } from './condition-switch-picker/condition-switch-picker.component';
import { AddLabelPickerComponent } from './add-label-picker/add-label-picker.component';

const Widges = [
  WidgetCheckGuideMenuComponent,
  WidgetDepositComponent,
  WidgetRemarkComponent
];

@NgModule({
  imports: [SharedModule, ComponentModule],
  declarations: [
    AddLabelPickerComponent,
    BreadcrumbComponent,
    MessageContainerComponent,
    MessageComponent,
    ClientComponent,
    MessageItemComponent,
    TodayOrTomorrowOrderListComponent,
    NoteV2Component,
    SynTaskListComponent,
    DuplicateGuestComponent,
    EditGuestComponent,
    GuestTagComponent,
    HourRoomCalendarComponent,
    VerticalTaskCalendarComponent,
    AirbnbAuthRequirementComponent,
    EditTemplateComponent,

    HouseOrderDetailComponent,
    HouseOrderBasicComponent,
    HouseOrderFinanceComponent,
    ContinueStayComponent,
    FinanceCompleteTableComponent,
    HouseOrderGuestComponent,
    OrderGuestDetailComponent,
    OrderGuestSimilarComponent,
    OrderDetailSidebarComponent,
    RateDetailComponent,

    EditRateComponent,
    RateTplPickerComponent,
    CreateTaskComponent,
    TaskDetailSidebarComponent,
    DepositComponent,

    HouseSelectComponent,
    CleanerAssignPickerComponent,
    BaseCalendarComponent,
    OversaleCalendarComponent,
    StopHouseCalendarComponent,
    ConditionSwitchPickerComponent,
    // HouseOrderDetailComponent,
    // AuditDetailsComponent,
    // FailHousesComponent,
    // CouponListComponent
    ...Widges
  ],
  exports: [
    AddLabelPickerComponent,
    BreadcrumbComponent,
    ClientComponent,
    MessageItemComponent,
    TodayOrTomorrowOrderListComponent,
    HourRoomCalendarComponent,
    VerticalTaskCalendarComponent,
    EditTemplateComponent,

    OrderGuestDetailComponent,
    OrderGuestSimilarComponent,
    RateDetailComponent,
    OrderDetailSidebarComponent,
    RateTplPickerComponent,
    TaskDetailSidebarComponent,

    HouseSelectComponent,
    CleanerAssignPickerComponent,
    OversaleCalendarComponent,
    StopHouseCalendarComponent,
    ConditionSwitchPickerComponent,
    // MessageContainerComponent,
    // MessageComponent,
  ],
  providers: [MESSAGE_DEFAULT_CONFIG_PROVIDER],
  entryComponents: [
    // MessageContainerComponent,
    // MessageComponent,
    // ClientComponent,

    // CouponListComponent,
    // SystemNotificationComponent,
    // NoteV2Component,
    // SynTaskListComponent,
    // DuplicateGuestComponent,
    // EditGuestComponent,
    // // HouseOrderDetailComponent,
    // AuditDetailsComponent,
    // FailHousesComponent,
    // AirbnbAuthRequirementComponent,
    // EditTemplateComponent,

    // HouseOrderDetailComponent,
    // HouseOrderBasicComponent,
    // HouseOrderFinanceComponent,
    // HouseOrderGuestComponent,
    // OrderGuestDetailComponent,
    // OrderGuestSimilarComponent,
    // ContinueStayComponent,

    // EditRateComponent,
    // CreateTaskComponent,
    // DepositComponent,
    // CleanerAssignPickerComponent,
    // OversaleCalendarComponent,
    // StopHouseCalendarComponent,
  ],
})
export class ModuleSharedComponentModule {
  constructor() {
    console.log('[Init Done]: ModuleSharedComponentModule');
  }
}
